import {
  NotificationActions,
  NotificationStatus,
  NotificationTypes
} from '@app/entities/enums/notification/notification.enum';

export class Notification {
  userID!: string;
  id!: string;
  title!: string;
  description!: string;
  action!: NotificationActions;
  type!: NotificationTypes;
  category?: number;
  status!: NotificationStatus;
  created?: string;
  page?: string;
  section?: string;
  item_id?: string;
  thumbnail?: string;
  translationKey!: string;
}

export class NotificationAll {
  title!: string;
  description!: string;
  segmentDelay!: number;
}
